import React from 'react'; //eslint-disable-line

const MainContainer = (props) => {
  // const location = useLocation();

  return (
    <div className="grid-container">
      {props.children}
    </div>
  );
};

export default MainContainer;
